const emailsTemplateBehaviourOptions = Object.freeze({
  Overwrite: 'Overwrite',
  Append: 'Append',
  Skip: 'Skip',
});

export default emailsTemplateBehaviourOptions;
